// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Caml_array from "rescript/lib/es6/caml_array.js";
import * as Path$LiteracyplanetClientFlags from "./Path.res.mjs";

function makePath(param) {
  return Path$LiteracyplanetClientFlags.use(function (param) {
              return window.location.pathname;
            });
}

var BrowserHistoryMatcher = {
  makePath: makePath
};

function makePath$1(param) {
  var splitPath = Js_string.split("?", window.location.hash);
  var firstPathItem = Caml_array.get(splitPath, 0);
  return Path$LiteracyplanetClientFlags.use(function (param) {
              return Js_string.sliceToEnd(1, firstPathItem);
            });
}

var HashHistoryMatcher = {
  makePath: makePath$1
};

var makePath$2 = process.env.HISTORY === "hash" ? makePath$1 : makePath;

export {
  BrowserHistoryMatcher ,
  HashHistoryMatcher ,
  makePath$2 as makePath,
}
/* makePath Not a pure module */
